module.exports = __webpack_public_path__ + "img/alert-modal-icon.b58d7b22.png";